var o = Object.defineProperty;
var n = (s, e, a) => e in s ? o(s, e, { enumerable: !0, configurable: !0, writable: !0, value: a }) : s[e] = a;
var t = (s, e, a) => n(s, typeof e != "symbol" ? e + "" : e, a);
import { makeAutoObservable as c } from "mobx";
import { AlertType as h } from "./chunk.js";
class i {
  constructor() {
    t(this, "_alertType", h.Success);
    t(this, "_message", null);
    t(this, "_show", !1);
    t(this, "closeSnackbar", () => {
      this._show = !1;
    });
    t(this, "showSnackbar", (e, a) => {
      this._alertType = e, this._message = a, this._show = !0;
    });
    c(this);
  }
  get alertType() {
    return this._alertType;
  }
  get message() {
    return this._message;
  }
  get show() {
    return this._show;
  }
}
const r = new i(), m = (s, e) => {
  r.showSnackbar(s, e);
}, _ = () => {
  r.closeSnackbar();
};
export {
  i as MainSnackbarStore,
  _ as hideSnackbar,
  r as mainSnackbarStore,
  m as showSnackbar
};
